// TalkRobin: alerts are on out of the box. New chats and chats assigned to
// you ring until opened, unless the agent turns that off in their profile.
export const DEFAULT_AUDIO_ALERT_TYPE = 'assigned+unassigned';

export const audioAlertSettings = (uiSettings = {}) => ({
  audioAlertType: uiSettings.enable_audio_alerts || DEFAULT_AUDIO_ALERT_TYPE,
  ringUntilOpened: uiSettings.ring_until_opened ?? true,
});
